import { useEffect } from "react";

interface SeoOptions {
  title: string;
  description?: string;
  keywords?: string;
}

function setMeta(name: string, content: string, attr: "name" | "property" = "name") {
  if (!content) return;
  let tag = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attr, name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

export function useDocumentTitle({ title, description, keywords }: SeoOptions) {
  useEffect(() => {
    document.title = title;
    setMeta("description", description || "");
    if (keywords) setMeta("keywords", keywords);
    setMeta("og:title", title, "property");
    setMeta("og:description", description || "", "property");
  }, [title, description, keywords]);
}